module.exports = __webpack_public_path__ + "static/media/TelaRosaPc.fd468e2f.jpg";